import { searchRoute } from '@lessonup/typescript-core/services';
import { ActionButton, RocketFlightSvg } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './ErrorPage.less';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
const GenericErrorPage: React.FC = (props) => {
  const { t } = useTranslation('errors');
  return (
    <div className="error-page-container">
      <div className="error-page error-page-500">
        <RocketFlightSvg />
        <p className="error-description">{t('default')}</p>
        <Link to={searchRoute()}>
          <ActionButton className="error-page-back">{t('error-page-back')}</ActionButton>
        </Link>
      </div>
    </div>
  );
};

export default GenericErrorPage;
